export default {
  zh: {
    shared: '已分享',
  },
  en: {
    shared: 'Shared',
  },
};




// WEBPACK FOOTER //
// ./src/components/ui/SharedStatusIcon/i18n.js